module.exports = __webpack_public_path__ + "static/img/13bg_4.d35a112.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/13bg_4.png
// module id = 649
// module chunks = 1